import { RulesService } from '@/services/rules.service';
import { RuleNames, RulesServiceStates, RulesServiceTypes, RulesServiceConfig } from '@/services/rules.service.config';
import _ from 'lodash';

export const validationMixin = {
	data() {
		return {
			validationResults: [],
			validationTypes: {
				participants: [RuleNames.adultMinor, RuleNames.participantSelection],
				spot: [RuleNames.spotSelection],
				notifications: RulesServiceConfig.getNotificationErrors()
			},
			rules: null,
			specialRequirements: []
		};
	},
	methods: {
		buildRules(data) {
			if (!data.validation) return;
			this.rules = data.validation.rules;

			const extraConditions = RulesService.getExtraConditions(this.rules);
			this.specialRequirements = extraConditions.specialRequirements;
		},

		validateComplete() {
			this.validationResults = RulesService.validateClient(
				this.rules,
				{
					selectedParticipants: _.filter(this.unregisteredMembers, m => this.selectedMemberIds.includes(m.id))
				},
				RulesServiceTypes.REGISTRATION,
				RulesServiceStates.DETAILS_PAGE,
				[
					RuleNames.authenticated
				]
			);
			return this.validationResults.length === 0;
		},

		buildNotificationMessage(fromServer) {
			let message = '';
			for (const err of this.validationResults) {
				if (this.validationTypes.notifications.includes(err.name)) {
					message += err.message + '<br>';
				}
			}
			if (message || fromServer) {
				this.mountServerError(false, message || '');
			}
		}
	}
};
